// Firebase initialization helper. Analytics is loaded only after consent.
// Firestore is intentionally NOT imported here: it's only needed by the
// lazy-loaded blog/admin routes, and importing it eagerly would pull its
// code into the main bundle used by every page (including the home page).
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBb7bqu_Wmzi-PxhN5RfxYAcrQS1T3qtpU",
  authDomain: "angelo-falci.firebaseapp.com",
  projectId: "angelo-falci",
  storageBucket: "angelo-falci.firebasestorage.app",
  messagingSenderId: "972341370526",
  appId: "1:972341370526:web:9170dbd864f2647d50e58f",
  measurementId: "G-6JQZWX16BH"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Connect to emulators in development
if (window.location.hostname === "localhost") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
}

let analyticsInstance: any = null;

export async function initAnalytics() {
  if (analyticsInstance) return analyticsInstance;
  if (typeof window === "undefined" || typeof window.document === "undefined") return null;
  try {
    const mod = await import(/* webpackChunkName: "firebase-analytics" */ "firebase/analytics");
    analyticsInstance = mod.getAnalytics(app);
    return analyticsInstance;
  } catch (e) {
    // Analytics may fail if cookies are blocked or measurement isn't available.
    return null;
  }
}

export { app };
